<template>
  <canvas
    ref="tankCanvas"
    style="position: absolute; width: 100%; height: 100%"
  ></canvas>
</template>

<script>
import { mapGetters } from "vuex";

import emptyTankWithoutShadeImageSrc from "@/plugins/tank_canvas/assets/empty_tank_without_shade.png";
import emptyTankWithShadeImageSrc from "@/plugins/tank_canvas/assets/empty_tank_with_shade.png";
import tankLiquidImageSrc from "@/plugins/tank_canvas/assets/tank_liquid.png";

export default {
  name: "koiote-tank-canvas",

  props: {
    input: Object,
  },

  data() {
    return {
      emptyTankWithShadeImage: null,
      emptyTankWithoutShadeImage: null,
      tankLiquidImage: null,
    };
  },

  computed: {
    allImagesLoaded() {
      return this.emptyTankWithShadeImage != null && this.emptyTankWithoutShadeImage != null && this.tankLiquidImage;
    },

    value() {
      return (
        this.actualPage()
          .global_item_list.find((gi) => gi.settings.component_type.includes("connection"))
          .customized.vartable.find((v) => v.formatted_address == this.input.customized.address)?.value || 0
      );
    },
  },

  methods: {
    ...mapGetters(["actualPage"]),

    async applyMask() {
      const canvas = this.$refs.tankCanvas;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      if (this.emptyTankWithoutShadeImage && this.tankLiquidImage && this.emptyTankWithShadeImage && canvas) {
        const newHeight = (this.value * canvas.height) / (this.input?.customized?.maximum_value || 100);

        const dy = canvas.height - newHeight;
        await ctx.drawImage(this.tankLiquidImage, 0, dy, canvas.width, newHeight);

        ctx.globalCompositeOperation = "destination-in";
        await ctx.drawImage(this.emptyTankWithoutShadeImage, 0, 0, canvas.width, canvas.height);

        ctx.globalCompositeOperation = "multiply";
        await ctx.drawImage(this.emptyTankWithShadeImage, 0, 0, canvas.width, canvas.height);
      }
    },

    loadEmptyTankWithShadeImage() {
      const img = new Image();
      img.src = emptyTankWithShadeImageSrc;
      img.onload = () => (this.emptyTankWithShadeImage = img);
    },

    loadEmptyTankWithoutShadeImage() {
      const img = new Image();
      img.src = emptyTankWithoutShadeImageSrc;
      img.onload = () => (this.emptyTankWithoutShadeImage = img);
    },

    loadTankLiquidImage() {
      const img = new Image();
      img.src = tankLiquidImageSrc;
      img.onload = () => (this.tankLiquidImage = img);
    },
  },

  mounted() {
    this.loadEmptyTankWithShadeImage();
    this.loadEmptyTankWithoutShadeImage();
    this.loadTankLiquidImage();
  },

  watch: {
    value() {
      this.applyMask();
    },

    allImagesLoaded(value) {
      if (value) this.applyMask();
    },

    input: {
      handler() {
        this.applyMask();
      },
      deep: true,
    },
  },
};
</script>
